import React from 'react';
import classnames from 'classnames';
import { COLUMN_TYPE } from '@zmedia/bm-soccer-ui/constants';
import Element from '../../element';
import styles from './column.module.scss';

interface IProps {
    children: React.ReactNode;
    className?: string;
    type?: COLUMN_TYPE;
}

export function Column(props: IProps) {
    const { children, className, type, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(className, styles['column'], {
                [styles[`column-${type}`]]: type,
            })}
        >
            {children}
        </Element>
    );
}
